import { LockClosedIcon } from "@heroicons/react/24/solid";
import { AnimatePresence, motion } from "framer-motion";
import Cta from "ui/organisms/Navbar/Cta";
import { AuthState } from "util/useAuth/types";

interface Props {
  locked: boolean;
  auth: AuthState;
}

export default function LockedOverlay({ locked, auth }: Props) {
  return (
    <AnimatePresence>
      {locked && (
        <Cta auth={auth} type="both">
          {({ text }) => (
            <div className={"absolute inset-0 z-10 bg-purple-950/75 group"}>
              <div className={"sticky top-1/3 flex flex-col items-center p-5"}>
                <motion.div
                  className="group cursor-not-allowed z-90 translate-x-0 mb-4 "
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ staggerChildren: 2 }}
                >
                  <LockClosedIcon className="z-10 h-20 text-white group-hover:animate-wiggle-more group-hover:animate-infinite" />
                </motion.div>

                <div className={"text-white translate-x-0 z-90 text-center"}>
                  <div
                    className={
                      "font-brik leading-none text-xl bg-black inline-block py-1 px-2 mb-1"
                    }
                  >
                    Out of lives for the day!
                  </div>

                  <br />

                  {<div className={"bg-black inline-block px-2"}>{text}</div>}
                </div>
              </div>
            </div>
          )}
        </Cta>
      )}
    </AnimatePresence>
  );
}
